import React, { forwardRef } from 'react';
import { Translate } from '@/components';
import { cx } from '@emotion/css';
import styles from './Tag.styles';

export type TagVariantType =
  | 'startDate'
  | 'deadline'
  | 'outline'
  | 'new'
  | 'greyOutline'
  | 'expired'
  | 'timeline'
  | 'filled'
  | 'viewed'
  | 'beta'
  | 'community'
  | 'free'
  | 'active';

export interface Props {
  children?: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: () => void;
  variant: TagVariantType;
  className?: string;
}

export const Tag = forwardRef<HTMLDivElement, Props>(
  ({ children, onClick, leftIcon, rightIcon, variant, className }, ref) => (
    <div
      ref={ref}
      className={cx(styles.tag, styles.variants[variant], className, onClick && styles.clickable)}
      onClick={onClick}
    >
      {leftIcon}
      {children && <Translate>{children}</Translate>}
      {rightIcon}
    </div>
  )
);

Tag.displayName = 'Tag';
